/*
  HLL visual pass: "Quick view" always opens the popup.

  How the theme works: the popup for a product is only fetched the first
  time the pointer moves over its tile. Until that has finished (usually
  about half a second) the Quick view button lets clicks fall through to
  the product link behind it, so a quick click lands on the product page.

  This script makes the button wait. A click before the popup is ready
  starts the same fetch if it has not started, and opens the popup the
  moment it is ready. If the popup has not arrived after 10 seconds it
  falls back to the product page, so the button never does nothing.

  The popup itself is still the theme's (theme.preloadProductModal and
  theme.Modals in assets/theme.js). Section 19 of assets/hll-visual-pass.css
  holds the two style rules. Remove both and the theme behaves as before.
*/
(function () {
  'use strict';

  var NOT_READY = 'quick-product__btn--not-ready';
  var WAITING = 'hll-quick-loading';
  var RETRY_AFTER = 4000; // ms before asking the theme for the popup directly
  var GIVE_UP_AFTER = 10000; // ms before going to the product page instead

  // The style rule that makes the button clickable early only applies when
  // this script is running
  document.documentElement.classList.add('hll-quick-view');

  function productUrl(tile) {
    var link = tile ? tile.querySelector('a.grid-product__link[href], a[href*="/products/"]') : null;
    return link ? link.href : '';
  }

  function open(button) {
    button.classList.remove(WAITING);
    button.removeAttribute('aria-busy');
    button.hllWaiting = false;
    button.click();
  }

  function wait(button) {
    if (button.hllWaiting) return;
    button.hllWaiting = true;
    button.classList.add(WAITING);
    button.setAttribute('aria-busy', 'true');

    var tile = button.closest('.grid-product');
    var retry;
    var giveUp;

    var watcher = new MutationObserver(function () {
      if (button.classList.contains(NOT_READY)) return;
      watcher.disconnect();
      window.clearTimeout(retry);
      window.clearTimeout(giveUp);
      open(button);
    });
    watcher.observe(button, { attributes: true, attributeFilter: ['class'] });

    // Start the theme's own fetch if hovering has not started it yet
    if (tile) tile.dispatchEvent(new MouseEvent('mouseover', { bubbles: false }));

    // A tile the theme never set up (added to the page later) will not
    // react to that. Ask for the popup directly.
    retry = window.setTimeout(function () {
      if (!button.classList.contains(NOT_READY) || !tile) return;
      var holder = document.getElementById('QuickShopHolder-' + tile.dataset.productHandle);
      var empty = holder && !holder.firstElementChild;
      if (empty && window.theme && typeof window.theme.preloadProductModal === 'function') {
        window.theme.preloadProductModal(tile.dataset.productHandle, tile.dataset.productId, button);
      }
    }, RETRY_AFTER);

    giveUp = window.setTimeout(function () {
      if (!button.classList.contains(NOT_READY)) return;
      watcher.disconnect();
      button.classList.remove(WAITING);
      button.removeAttribute('aria-busy');
      button.hllWaiting = false;
      var url = productUrl(tile);
      if (url) window.location.href = url;
    }, GIVE_UP_AFTER);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest ? event.target.closest('.quick-product__btn') : null;
      if (!button || !button.classList.contains(NOT_READY)) return;
      event.preventDefault();
      event.stopPropagation();
      wait(button);
    },
    true
  );
})();
